import { FormGroup } from 'react-bootstrap'
import styled from 'styled-components'

export const FormField = styled(FormGroup)`
    .Select-control {
        #diagramEditor-hazardModal-field-operation {
            height: 34px;
            margin: 0px;
            padding: 0px;
        }
    }
`
